import { isValid, parse, parseISO } from 'date-fns';

export const parseDate = (dateString: string) => {
  if (!dateString) return null;
  if (dateString.includes('.')) {
    return parse(dateString, 'dd.MM.yyyy', new Date());
  }
  return parseISO(dateString);
};

export const getValidDate = (date: unknown): Date | null => {
  if (typeof date === 'string' || typeof date === 'number' || date instanceof Date) {
    const d = new Date(date);
    return isValid(d) ? d : null;
  }

  return null;
};

export const parseSqlDateTime = (input?: string | Date): Date | null => {
  if (!input) return null;
  if (input instanceof Date) return input;
  const isoLike = input.replace(' ', 'T');
  const date = new Date(isoLike);
  return Number.isNaN(date.getTime()) ? null : date;
};
